export const styles = {
  // Tags
  tagBox: (theme) => ({
    display: 'inline-flex',
    padding: '1px 4px',
    borderRadius: '4px',
    backgroundColor:
      theme.palette.mode === 'dark'
        ? 'rgba(255, 255, 255, 0.05)'
        : 'rgba(0, 0, 0, 0.04)',
    color: theme.palette.text.secondary,
    fontSize: '0.55rem',
    fontWeight: 600,
    border: `1px solid ${theme.palette.divider}`,
    whiteSpace: 'nowrap',
  }),

  // Mobile View
  mobileContainer: (theme) => ({
    p: 1,
    mb: 1,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 1,
    bgcolor: theme.palette.mode === 'dark' ? 'background.paper' : '#fff',
  }),
  mobileRow1: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 0.5,
    overflow: 'hidden',
  },
  mobileSymbolBox: { display: 'flex', alignItems: 'center', gap: 0.5, minWidth: 0 },
  mobileSymbolText: {
    fontSize: { xs: '0.75rem', sm: '0.85rem' },
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    flexShrink: 1,
  },
  mobileExchangeText: { fontSize: '0.6rem', flexShrink: 0 },
  mobileTagsBox: { display: 'flex', gap: 0.5, flexShrink: 0 },
  mobileSideChip: { height: 20, fontSize: '0.65rem', ml: 1, flexShrink: 0 },

  mobileRowData: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    mt: 1,
  },
  mobileDataColLeft: { flex: 1 },
  mobileDataColCenter: { flex: 1, textAlign: 'center' },
  mobileDataColRight: { width: 40, textAlign: 'right' },
  mobileDataLabel: { fontSize: '0.65rem', display: 'block', lineHeight: 1 },
  mobileDataValue: {
    fontSize: '0.75rem',
    mt: 0.5,
    wordBreak: 'break-all',
  },
  mobileActionBtn: (theme) => ({
    p: 0.5,
    border: `1px solid ${theme.palette.divider}`,
  }),
  mobileActionIcon: { fontSize: '1rem' },

  // Desktop View
  desktopTableRow: (theme) => ({
    '&:last-child td, &:last-child th': { border: 0 },
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  }),
  desktopSymbolBox: { display: 'flex', alignItems: 'baseline', gap: 1 },
  desktopTagsBox: { display: 'flex', gap: 0.5, mt: 0.5 },
  desktopActionsBox: { display: 'flex', justifyContent: 'center', gap: 1 },
};
